








import { Component, Vue } from 'vue-property-decorator';
import { IUserRegistration } from '@/interfaces';
import { showAxiosErrorMessage } from '@/utils';

import ParentRegistrationForm from '@/components/forms/ParentRegistrationForm.vue';

@Component({
  name: 'register-page',
  components: { ParentRegistrationForm }
})
export default class RegisterComponent extends Vue {
  /**
   * Loading data into the system
   */
  public loading = false;

  /**
   * Submit trigger method that is meant to register a user and send them to the login page if everything returned good
   * 
   * @param user The user registration we should be creating
   */
  public async submit(user: IUserRegistration) {
    try {
      this.loading = true;
      if (await this.$store.dispatch('parentRegister', user)) {
        this.$alert.success('Registration Complete', 'Please check your email');
        this.$router.push('/user/login');
      }
    } catch(ex) {
      showAxiosErrorMessage(ex);
    } finally {
      this.loading = false;
    }
  }
}
